export default __webpack_public_path__ + "static/media/block_card.e383ca23.svg";